<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 7H6C6.55228 7 7 7.52233 7 8.16667V19.8333C7 20.4777 6.55228 21 6 21H4C3.44772 21 3 20.4777 3 19.8333V8.16667C3 7.52233 3.44772 7 4 7Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 3H20C20.5523 3 21 3.67157 21 4.5V19.5C21 20.3284 20.5523 21 20 21H18C17.4477 21 17 20.3284 17 19.5V4.5C17 3.67157 17.4477 3 18 3Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 13H13C13.5523 13 14 13.398 14 13.8889V20.1111C14 20.602 13.5523 21 13 21H11C10.4477 21 10 20.602 10 20.1111V13.8889C10 13.398 10.4477 13 11 13Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default { name: 'VerticalBarChart' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
